module.exports = __webpack_public_path__ + "img/rising-anxiety.f342dda4.svg";